import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { investmentPlans } from "../../../../data";
import { minerData } from "../../../../data";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormModal from "./FormModal";

export default function Two() {
	// const content = (
	// 	<Box>
	// 		{/* INVESTMENT PLANS */}
	// 		<section className=" w-full  text-black  bg-white  mt-[1rem]">
	// 			<section className="w-full flex flex-col text-center  gap-5 lg:flex-row justify-center  items-center  p-4  ">
	// 				<motion.h5
	// 					viewport={{ once: true }}
	// 					animate={{ opacity: 0, y: 80 }}
	// 					whileInView={{ opacity: 1, y: 0 }}
	// 					transition={{ duration: 1.5 }}
	// 					className="text-[1.5rem]  text-center  mx-auto  font-serif  tracking-wider p-[0.3rem] ">
	// 					Initiate your earning process by selecting your most prefered plan
	// 				</motion.h5>
	// 				{/* <img src={choosepl} alt="experts" className="" /> */}
	// 			</section>
	// 			<motion.section
	// 				viewport={{ once: true }}
	// 				animate={{ opacity: 0, y: 50 }}
	// 				whileInView={{ opacity: 1, y: 0 }}
	// 				transition={{ duration: 1.5 }}
	// 				className="w-[98%] mx-auto my-3        grid  gap-4   grid-cols-2 ">
	// 				{investmentPlans.map((data) => (
	// 					<div
	// 						key={data.id}
	// 						className=" w-full  md:w-[90%]  md:mx-auto min-h-full  bg-gray-100     flex flex-col    gap-3 p-1  justify-around  items-center ">
	// 						<h3 className="text-[1.1rem] tracking-wide  font-bold  text-black">
	// 							{data.name}
	// 						</h3>
	// 						<motion.ul
	// 							viewport={{ once: true }}
	// 							animate={{ opacity: 0, x: 50 }}
	// 							whileInView={{ opacity: 1, x: 0 }}
	// 							transition={{ duration: 1.5 }}
	// 							className=" min-w-full  h-full flex  gap-2 flex-col justify-around  p-[0.5rem]  border-2  border-gray-400 items-center">
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Captital back:</span>
	// 								<span className="plan-value-style">{data.CB}</span>
	// 							</li>
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Withdrawal:</span>
	// 								<span className="plan-value-style">Anytime</span>
	// 							</li>
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Min Amount:</span>
	// 								<span className="plan-value-style">${data.minAmount}</span>
	// 							</li>
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Max Amount:</span>
	// 								<span className="plan-value-style">${data.maxAmount}</span>
	// 							</li>
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Daily profit:</span>
	// 								<span className="plan-value-style">%{data.ROI}</span>
	// 							</li>
	// 							<li className="li-plan-style">
	// 								<span className="plan-field-style">Referal Commission:</span>
	// 								<span className="plan-value-style">{data.RC}</span>
	// 							</li>
	// 						</motion.ul>
	// 						<FormModal
	// 							minAmount={data.minAmount}
	// 							maxAmount={data.maxAmount}
	// 							plan={data.name}
	// 							roi={data.ROI}
	// 						/>

	// 					</div>
	// 				))}
	// 			</motion.section>
	// 		</section>
	// 	</Box>
	// );

	const content = (
		<Box>
			<section className="w-full  lg:w-[85%]  lg:mx-auto   bg-black flex  flex-col  lg:flex-row  lg:justify-center  lg:items-center    text-white   p-[0.6rem]      my-[1rem]">
				{/* MINING BOT PLAN */}
				<div className="">
					<h4 className="min-w-fit mx-auto  text-center font-bold  text-[1.4rem]  ">
						Advanved Crypto Miners
					</h4>
					<ul className="flex   flex-col   md:flex-row justify-center  my-[1rem]  items-center  gap-[1rem]">
						{minerData.map((data) => (
							<li
								key={data.id}
								className="w-[90%]   min-h-full  mx-auto p-[1rem]  bg-gray-900   border-2 border-green-500   rounded-[1.5rem]  text-center  flex   flex-col  justify-center  items-center  gap-[1rem]">
								<div className="text-[3rem]  text-blue-200">{data.logo}</div>
								<h5 className="font-bold  text-white capitalize  text-[1.1rem] ">
									{data.title}
								</h5>
								<ul className=" min-h-full       list-disc list-inside text-left">
									<li className="text-gray-400 text-[0.9rem]  ">{data.desc}</li>
									<li className="text-gray-400 text-[0.9rem]  ">
										Price: ${data.price}
									</li>
									<li className="text-gray-400 text-[0.9rem]  ">
										Hashrate: {data.hashRate}TH/s
									</li>

									<li className="text-gray-400 text-[0.9rem]  ">
										Daily earning: {data.dailyEarning}
									</li>

									<li className="text-gray-400 text-[0.9rem]  ">
										Weekly Payout: {data.weeklyPayout}
									</li>
									<li className="text-gray-400 text-[0.9rem]  ">
										Withdrawal: {data.withdrawal}
									</li>
								</ul>

								<FormModal
									price={data.price}
									hash={data.hashRate}
									minerName={data.title}
									minerId={data.id}
								/>
								{/* <Link
								to="en/register"
								className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-300">
								Register to Buy Now
							</Link> */}
							</li>
						))}
					</ul>
				</div>
			</section>
		</Box>
	);

	return content;
}
